// extracted by mini-css-extract-plugin
export var lg = "_45-4";
export var md = "_45-3";
export var sm = "_45-2";
export var xs = "_45-1";
export var xxs = "_45-0";